import React, { useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import InputMask from 'react-input-mask'

function ModalIncluirCliente({ onSaveCliente, onCancel }) {
  const [cpfCnpj, setCpfCnpj] = useState('')
  const [nome, setNome] = useState('')
  const [cpfCnpjError, setCpfCnpjError] = useState('')
  const [nomeError, setNomeError] = useState('')
  const [isCpf, setIsCpf] = useState(true)

  const validateCpfCnpj = (input) => {
    const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
    const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
    return cpfRegex.test(input) || cnpjRegex.test(input)
  }

  const handleInputChange = (e) => {
    const inputVal = e.target.value
    const numbersOnly = inputVal.replace(/\D/g, '') // Remove non-numeric characters

    // Determine the mask to use based on the input length
    const mask = isCpf ? '999.999.999-99' : '99.999.999/9999-99'

    // Create the value with mask characters
    let maskedValue = ''
    let valueIndex = 0
    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === '9') {
        maskedValue += numbersOnly[valueIndex]
        valueIndex++
      } else {
        maskedValue += mask[i]
      }
    }

    setCpfCnpj(maskedValue)
  }

  const handleSelectChange = (e) => {
    setIsCpf(e.target.value === 'cpf')
    setCpfCnpj('')
  }

  const handleSubmit = () => {
    let isFormValid = true

    if (!validateCpfCnpj(cpfCnpj)) {
      setCpfCnpjError('CPF ou CNPJ inválido')
      isFormValid = false
    } else {
      setCpfCnpjError('')
    }

    if (nome.trim() === '') {
      setNomeError('Campo obrigatório')
      isFormValid = false
    } else {
      setNomeError('')
    }

    if (isFormValid) {
      onSaveCliente({ cpfCnpj, nome })
    }
  }

  return (
    <Modal
      show={true}
      onHide={onCancel}
    >
      <Modal.Header closeButton>
        <Modal.Title>Incluir Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formBasicSelect">
            <Form.Label>Selecione o tipo de documento</Form.Label>
            <Form.Control
              as="select"
              value={isCpf ? 'cpf' : 'cnpj'}
              onChange={handleSelectChange}
            >
              <option value="cpf">CPF</option>
              <option value="cnpj">CNPJ</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="formBasicCPF">
            <Form.Label>{isCpf ? 'CPF' : 'CNPJ'}</Form.Label>
            <InputMask
              mask={isCpf ? '999.999.999-99' : '99.999.999/9999-99'}
              value={cpfCnpj}
              onChange={handleInputChange}
            >
              {(inputProps) => (
                <Form.Control
                  type="text"
                  {...inputProps}
                  placeholder={`Digite o ${isCpf ? 'CPF' : 'CNPJ'} do cliente`}
                  isInvalid={cpfCnpjError !== ''}
                />
              )}
            </InputMask>
            <Form.Control.Feedback type="invalid">
              {cpfCnpjError}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formBasicNome">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Digite o nome do cliente"
              isInvalid={nomeError !== ''}
            />
            <Form.Control.Feedback type="invalid">
              {nomeError}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
        >
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalIncluirCliente
